export default [
  {
    type: "epc",
    name: "",
    bic: "",
    empfaenger: "",
    iban: "",
    waehrung: ""
  },
  {
    type: "swiss",
    name: "Credit Suisse",
    bic: "CRESCHZZ80A",
    empfaenger: "H1 Zahnärzte",
    iban: "CH1604835185840591000",
    waehrung: "CHF",
    adresse: "Zentrum Staldenbach",
    hausnr: "2",
    plz: "8808",
    ort: "Pfäffikon",
    land: "CH"
  }
]
